import React from 'react'
import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/OverviewHeight/OverviewHeight'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'
import { CaseCTAItem } from 'components/cases/common/CaseCTA'
import { CaseDownloadCTAItem } from 'components/cases/common/CaseDownloadCTA'

// ファーストビュー
export const firstViewItemWhite = {
  breadcrumb: '課題解決率が大幅向上 - “使える生成AIチャット”をアジャイル×UX/UIでスピード実現',
  title1: <>課題解決率が大幅向上 - “使える生成AIチャット”をアジャイル×UX/UIでスピード実現</>,
  company: '株式会社大和総研',
  introduction_text: (
    <>
      ルールベース型のFAQチャットボットが金融機関の標準となる一方で、「知りたい答えにたどり着けない」「スピード感を持って改善できない」といった顧客体験の課題は残り続けていました。リサーチやコンサルティング、システム開発の知見を束ねてきた株式会社大和総研は、生成AIとアジャイル開発、そしてUX/UIデザインを組み合わせることで、金融機関の新しい顧客接点作りに踏み出しました。
    </>
  ),
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development/',
  tag2text: 'フロントエンド開発',
  tag2src: '/cases/frontend-dev/',
  tag3text: 'UX/UI改善',
  tag3src: '/cases/uxui-improvement/',
  tag4text: 'AI',
  tag4src: '/cases/ai/',
  industryTagText: 'IT/情報/通信',
  industryTagSrc: '/cases/telecommunications/',
  image: '/images/img/cases/dir/mv.webp',
  movie: '',
  alt: '株式会社大和総研 課題解決率が大幅向上 — “使える生成AIチャット”をアジャイル×UX/UIでスピード実現',
}

// プロジェクト概要
export const overviewTitle = 'デザイン×アジャイルで顧客体験向上をスピーディに実現'

export const overviewItem: OverviewItems[] = [
  {
    text: '金融サービスを取り巻く環境は、テクノロジーの進化と顧客ニーズの多様化により、かつてないスピードで変化しています。特に、生成AIの進化は、企業の顧客対応のあり方を根本から変えようとしています。',
  },
  {
    text: '今回ご紹介する事例は、金融機関における顧客対応の高度化を目指す生成AIチャットサービス。従来のルールベース型からデータ量を2.5倍に拡張し、お客さまからの質問意図を柔軟に理解し、適切に回答できる新サービスへの刷新を、アイスリーデザインが支援しました。',
  },
  {
    text: '顧客対応の迅速化と品質向上を目指すこの長期的な取り組みを推進するにあたり、プロジェクトを牽引する大和総研がパートナーとして選んだのが、アジャイル開発、UX/UIデザイン、および技術力をトータルで提供できるアイスリーデザインでした。',
  },
  {
    text: '今回は、大和総研からプロジェクト責任者の泉さん、PMの近藤さん、PLの林さん、開発担当者の松井さん、アイスリーデザインからPMの平、UIデザイナーの高篠を交え、プロジェクトの舞台裏に迫りました。アジャイル開発の採用理由、デザイナーがスクラムに参加した価値、そしてリリース後の具体的な成果について掘り下げます。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: '既存AIチャットの機能と対応範囲の限界',
        text: 'ルールベースの既存チャットでは、決まった質問にしか回答できず、お客さまが知りたい情報にたどり着きにくいという、顧客体験上の課題があった。',
      },
      {
        title: 'UX/UIデザインの専門性不足',
        text: '金融向けの堅実なシステム開発が多く、UX/UIデザインの知見やノウハウが不足しており、お客さまにとって使いやすい画面やインターフェースの実現が難しかった。',
      },
      {
        title: 'ウォーターフォールからの開発手法の転換',
        text: '「早くサービスを提供し、継続的に改善する」という目的に対し、従来のウォーターフォール開発ではスピードが追いつかず、アジャイル開発の経験も不足していた。',
      },
    ],
    solutions: [
      {
        title: '生成AIチャットの顧客体験向上',
        text: '大和総研側が構築したRAG（生成AIチャットの頭脳）が最大限活用されるよう、チャットアプリケーション側のUI、接続方式、ユーザー体験を最適化。お客さまが質問意図を入力しやすく、適切な情報にスムーズにたどり着けるインターフェースを提供することで、RAGの回答精度を「体験」として向上させた。',
      },
      {
        title: 'アジャイル開発とデザインの専門性の提供',
        text: 'アジャイル開発にたけた体制を提供し、プロジェクト開始から1か月足らずでプロトタイプを作成。UX/UIデザインも担当し、デザインの意図を言語化することで、イメージを迅速に反映した。',
      },
      {
        title: 'AI駆動開発による開発プロセスの高速化と品質向上',
        text: 'Cursorを活用し、設計フェーズにおけるAI支援を取り入れることで、仕様策定から詳細設計、タスク分解までを効率化した。また、コードレビューにはAIを導入し、指摘の自動化やチェックの標準化を行うことでレビュー速度と品質を向上。さらに、AIによる議事録の自動要約やリスト化を取り入れ、情報整理の手間を削減することで、開発サイクル全体のスピードと品質向上を実現した。',
      },
    ],
  },
]

// CTA
export const caseCTAItem: CaseCTAItem = {
  title: '"早く出して、改善し続ける"を、AI駆動で。',
  description: (
    <>
      AI駆動開発・アジャイル・UX/UIの専門知識を、Oneチームでご提供します。
      <br />
      まずは、現在の課題やお悩みをお聞かせください。
    </>
  ),
}

// 資料ダウンロード CTA
export const caseDownloadCTAItem: CaseDownloadCTAItem = {
  title: 'アプリ開発RFP作成のポイント',
  description: 'アプリ開発担当者向けに、失敗しないためのポイントをテンプレート付の1冊にまとめました',
  imageSrc: '/images/img/cases/cta_rfp.webp',
  href: '/download/rfp/',
}

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
